import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function CallForTutorials() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const proposalRequirements = [
    'Proposed title of the short course/tutorial',
    'Proposers\' names, affiliations, contact details, and brief biographies',
    'Tutorial description: List of topics, brief outline, and survey of literature (including 10 most important works)',
    'A description of how the proposed tutorial fits the scope of NCVPRIPG',
    'Details of external presenters (if any) with links to websites and Google Scholar profiles',
    'Any special requirements related to space or logistics'
  ];

  const importantDates = [
    { event: "Tutorial Proposal Submission Starts", date: "March 2, 2026" },
    { event: "Tutorial Proposal Submission Deadline", date: "March 31, 2026" },
    { event: "Notification of Accepted Proposals", date: "April 15, 2026" }
  ];

  return (
    <div className="page-container">
      <PageCarousel />
      
      <section className="section-padding bg-white">
        <div className="container">
          
          {/* 1. Header & Intro */}
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h1 className="section-title" style={{ fontWeight: 700, color: '#111' }}>Call for Tutorials</h1>
              <div style={{ width: '80px', height: '4px', background: '#70b60a', margin: '15px auto' }}></div>
              <p className="col-lg-10 mx-auto mt-4 text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
                We invite proposals for short courses/tutorials (duration: 3 hours) to be organized as part of the NCVPRIPG 2026 at LNMIIT Jaipur. 
                Proposals should focus on recent trends and tools in computer vision, pattern recognition, image processing, and graphics. 
                We expect these tutorials to attract a diverse audience, from students to seasoned researchers.
              </p>
            </div>
          </div>

          {/* 2. Proposal Requirements Card */}
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto">
              <div className="p-4 bg-light rounded shadow-sm border">
                <h3 className="mb-4" style={{ color: '#70b60a', fontWeight: 600, fontSize: '22px' }}>
                   Proposal Requirements
                </h3>
                <div className="row">
                  {proposalRequirements.map((item, idx) => (
                    <div key={idx} className="col-12 d-flex align-items-start mb-3">
                      <i className="lni-check-mark-circle text-success mt-1 mr-3"></i>&nbsp;
                      <span style={{ fontSize: '16px', color: '#333' }}>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* 3. Submission Box */}
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto text-center">
              <div className="alert alert-info p-4 border-0 shadow-sm" style={{ borderRadius: '12px', background: '#eef7ff' }}>
                <h5 className="font-weight-bold mb-3" style={{ color: '#0056b3' }}>How to Submit?</h5>
                <p className="mb-3">All proposals must be submitted exclusively via the official form:</p>
                <a 
                  href="https://docs.google.com/forms/d/e/1FAIpQLSeiQuoc2lomsX30fyK_sTp87mXiZQRK23UFFx0oVTcOhbpDHw/viewform?usp=sharing&ouid=117929628141186061007" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-lg px-4 py-2"
                  style={{ background: '#70b60a', borderRadius: '30px', fontWeight: '600' }}
                >
                  <i className="lni-google mr-2"></i> Open Google Form
                </a>
                <p className="mt-3 small text-muted">
                  <strong>Note:</strong> Email submissions will not be considered.
                </p>
              </div>
            </div>
          </div>

          {/* 4. Important Dates Section (Sabse Niche) */}
          <div className="row mt-5">
            <div className="col-lg-10 mx-auto">
              <h3 className="mb-4" style={{ borderLeft: '5px solid #70b60a', paddingLeft: '15px', fontWeight: 600 }}>Important Dates</h3>
              <div className="table-responsive shadow-lg rounded" style={{ overflow: 'hidden' }}>
                <table className="table table-hover mb-0">
                  <thead style={{ background: '#70b60a', color: '#fff' }}>
                    <tr>
                      <th style={{ padding: '18px 25px', fontSize: '16px' }}>Event</th>
                      <th style={{ padding: '18px 25px', fontSize: '16px' }}>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importantDates.map((item, idx) => (
                      <tr key={idx}>
                        <td style={{ padding: '15px 25px', fontWeight: '500' }}>{item.event}</td>
                        <td style={{ padding: '15px 25px', color: '#70b60a', fontWeight: '700' }}>{item.date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              
              <div className="mt-5 p-4 text-center rounded bg-white border">
                 <p className="mb-0">
                   For any queries, please contact the Tutorial Chairs: <br />
                   <a href="mailto:lalupendrapratap.singh@lnmiit.ac.in" className="text-success font-weight-bold">
                     lalupendrapratap.singh@lnmiit.ac.in
                   </a>
                 </p>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default CallForTutorials;